<template>
  <div class="d-flex justify-content-center mt-5">
    <div class="btn-group">
      <a
        v-show="state.currentPage > 1"
        class="btn-nav btn btn-primary pagination-link-btn"
        @click="previous">
        <i class="fa fa-angle-left"/>
      </a>
      <a class="btn btn-primary hide-not-focused-btn focus">
        {{ state.currentPage }}
      </a>
      <a
        v-show="state.currentPage < state.totalPageCount"
        class="btn-nav btn btn-primary pagination-link-btn"
        @click="next">
        <i class="fa fa-angle-right"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    state: {
      type: Object,
      required: true
    },
    pageSelected: {
      type: Function,
      required: true
    }
  },
  methods: {
    next () {
      this.pageSelected(this.state.currentPage + 1)
    },
    previous () {
      this.pageSelected(this.state.currentPage - 1)
    }
  }
}
</script>
